<script>
import { bus } from '../main'
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            'saved_ids': 'list/saved_ids',
            'selected_ids': 'list/selected',
            'list_loaded': 'list/list_loaded',
        })
    },
    methods: {
        showLimitModal () {
            let msg =  this.$i18n.messages[this.$i18n.locale].overlimit_modal.hit_limit
            this.$store.dispatch('list/showModal', {
                display: true,
                msg: msg
            })
        },
        updateSelection(data,e) {
            e.preventDefault()

            if (this.isSelected(data.id)) {
                this.$store.dispatch("list/unstageItem", data.id)
            } else {
                if (data.type == 'selected') {
                    if (this.saved_ids.length + this.selected_ids.length + 1 > 500) {
                        this.showLimitModal()
                        return;
                    }
                }

                this.$store.dispatch("list/stageItem", data.id)
            }
        }, 
        updateSave(data,e) {
            e.preventDefault()
            if (this.isSaved(data.id)) {
                this.$store.dispatch("list/removeItem", data.id)
            } else {
                if (data.checkLimit) {
                    if (this.saved_ids.length >= 500) {
                        this.showLimitModal()
                        return;
                    }
                }
                this.$store.dispatch("list/addItem", data.id)
            }
        }, 
        isSaved (id) {
            return this.saved_ids.includes(id)
        },
        isSelected (id) {
            return this.selected_ids.includes(id)
        },
        clearSelected() {
            this.$store.dispatch("list/clearSelected")
        },
        saveAllSelected () {
            this.$store.dispatch("list/saveSelected")  
            bus.$emit('showMsg', this.$t("labels.saved_to_list" ));
        },
        removeAllSelected () {
            this.$store.dispatch("list/removeSelected")  
            this.$emit('removed')
            bus.$emit('showMsg', this.$t("labels.removed_from_list" ));
        }
    },
    mounted () {
        if (!this.listLoaded) {
            this.$store.dispatch('list/saved_ids')
        }
    }
}
</script>